import React from "react";
import { Stack, Typography } from "@mui/joy";

interface ThankYouMessageProps {
  fullName: string;
}

const ThankYouMessage: React.FC<ThankYouMessageProps> = ({ fullName }) => {

  return (
    <Stack spacing={1} className="mb-4">
      <Typography
        level="modalHeading"
        sx={{
          fontSize: { xs: "1.5rem", lg: "1.5rem" },
          mb: 0.5,
          lineHeight: 1.4,
        }}
      >
        Thank you, {fullName}
        <br />
        You're signed up!
      </Typography>
      <Typography
        level="description"
        sx={{
          fontSize: { xs: "1rem", lg: "1.125rem" },
          mb: 2,
        }}
      >
        Your video is live!
      </Typography>
    </Stack>
  );
};

export default ThankYouMessage;